<template>
    <div
        v-if="hasWritePermissions || isDemoUser"
        class="vrm-circle-icon-button"
        @click="openAIAssistantView"
    >
        <span class="sg-vrm-icon_149_ai-chat"></span>
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { ngInject } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-ai-assistant-overlay-button')
export default class VrmAIAssistantOverlayButton extends Vue {
    @ngInject()
    InstallationsService;
    @ngInject()
    UserService;
    @ngInject()
    vrmUserAccessLevel;

    isDemoUser = false;

    get hasWritePermissions() {
        return (
            this.installation &&
            this.installation.view_permissions &&
            this.installation.view_permissions.update_settings
        );
    }

    get installation() {
        return this.InstallationsService.activeInstallation;
    }

    async mounted() {
        this.isDemoUser = await this.isDemo();
    }

    async isDemo() {
        await this.UserService.getUser();
        return this.UserService.user.accessLevel === this.vrmUserAccessLevel.DEMO;
    }

    openAIAssistantView() {
        // Save the current route name so we can redirect back to it after the AI assistant is closed
        localStorage.setItem('vrm-ai-assistant-redirected-from', this.$route.name);
        this.$router.push({ name: 'ai-assistant', params: { id: this.$route.params.id } });
    }
}
</script>
